/*eslint-disable*/
import React from "react";
// react components for routing our app without refresh
import { Link } from "gatsby";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/icons
import { Apps, CloudDownload } from "@material-ui/icons";

// React icons
import { IoLogoGithub } from 'react-icons/io';

// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";
import Button from "components/CustomButtons/Button.jsx";

import headerLinksStyle from "assets/jss/material-kit-react/components/headerLinksStyle.jsx";

function HeaderLinks({ ...props }) {
  const { classes } = props;
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          buttonText="Download"
          buttonProps={{
            className: classes.navLink,
            color: "transparent"
          }}
          buttonIcon={CloudDownload}
          dropdownList={[
            <a
              target="_blank"
              className={classes.dropdownLink}
              href="https://drive.google.com/file/d/1x8SSpTMUY60Ygo2uEFbFf2l7ugRZ0mWl/view?usp=sharing">
              .ZIP
            </a>,
            <a
              target="_blank"
              className={classes.dropdownLink}
              href="https://drive.google.com/file/d/1j_isci6aP1zWze1XMAFWot6QrrZoW19n/view?usp=sharing">
              .TAR.GZ
            </a>
          ]}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          id="github-tooltip"
          title="Check out the source code"
          placement={typeof window !== 'undefined' && window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            href="https://github.com/kenystev/racergear"
            target="_blank"
            color="transparent"
            className={classes.navLink}
          >
            <IoLogoGithub/>
          </Button>
        </Tooltip>
      </ListItem>
    </List>
  );
}

export default withStyles(headerLinksStyle)(HeaderLinks);
